import { PaymentTransferType } from "../generated/graphql"

/**
 * Erkennt eine SEPA-Zahlungsmethode primär am Typ. Fallback auf vorhandene IBAN,
 * weil ältere Datensätze (z.B. aus der Admin-App) den Typ nicht immer gesetzt haben —
 * eine IBAN tragen aber ausschließlich SEPA-Methoden.
 */
export const isSepaPaymentMethod = (pm?: { type?: PaymentTransferType | null; iban?: string | null } | null): boolean =>
    !!pm && (pm.type === PaymentTransferType.SepaDebit || !!pm.iban)
